module.exports = __webpack_public_path__ + "assets/img/00084.e9bb13db.png";